import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Countdown } from '@shared/utils/Countdown';
import { AuthService } from '../../../modules/auth/auth.service';

@Component({
    selector: 'app-token-validate',
    templateUrl: './token-validate.component.html',
    styleUrls: ['./token-validate.component.scss'],
})
export class TokenValidateComponent implements OnInit {
    /**
     * Tipo de solicitação do token  0 - cadastro | 1 - recuperação de senha
     */
    @Input('type') type: '0' | '1';
    /**
     * ID do usuário para validação do token
     */
    private _player: string;
    @Input() set player(value: string) {
        this._player = value;
    }
    get player() {
        return this._player;
    }
    /**
     * Código secreto de validação do token
     */
    @Input() codeToken: string;

    /**
     * Extra data
     */
    @Input('extra') extra: Record<string, string>;

    /**
     * Tipo de envio
     */
    private _typeSending: number;
    @Input() set typeSending(value: number) {
        this._typeSending = value;
    }
    get typeSending() {
        return this._typeSending;
    }

    /**
     * Evento emitido ao validar o token
     */
    @Output() validate: EventEmitter<any> = new EventEmitter();

    /**
     * Determina se a opção para receber por sms está habilitada
     */
    receiveSmsDisabled: boolean = true;
    /**
     * Marcação do countdown
     */
    countdown: number;
    /**
     * Data da última cola
     */
    lastPaste: any = new Date();

    /**
     * Objeto para controlar e obter token
     */
    tokenControl = {
        input: ['', '', '', '', ''],
        token: '',
        valid: false,
    };

    loading: boolean = false;

    /**
     * Ref dos inputs
     */
    @ViewChildren('inputToken') inputs: QueryList<ElementRef<HTMLInputElement>>;

    constructor(
        private authService: AuthService,
        private toastrService: NbToastrService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.startCountdown();
        console.log(this.codeToken);
    }

    onRequestTokenViaSMS() {
        if (!this.player) {
            this.toastrService.danger(
                this.translateService.instant('ALERT.ERROR.TITLE'),
                this.translateService.instant('ALERT.ERROR.DESCRIPTION')
            );
            console.error(`ID do usuário não recebido`);
            return;
        }
        const type_sending = 2; // 2 - receber por sms
        this.authService.requestToken(this.player, type_sending, this.type, this.extra).subscribe((response) => {
            const success = response.status_code === 0;
            if (success) {
                this.codeToken = response.registers.code;

                this.toastrService.success(
                    this.translateService.instant('ALERT.SUCCESS.TITLE'),
                    this.translateService.instant('ALERT.SUCCESS.DESCRIPTION')
                );
                this.startCountdown(2);
            } else {
                this.toastrService.success(
                    this.translateService.instant('ALERT.ERROR.TITLE'),
                    this.translateService.instant('ALERT.ERROR.DESCRIPTION')
                );
                this.startCountdown(0.5);
            }
            this.receiveSmsDisabled = true;
        });
    }

    onValidateToken() {
        this.loading = true;
        this.authService.validateToken(this.player, this.tokenControl.token, this.codeToken).subscribe((response) => {
            this.loading = false;
            if (response.status_code === 0) {
                this.validate.emit(this.tokenControl.token);
            } else {
                this.toastrService.danger(response.description, this.translateService.instant('ALERT.ERROR.TITLE'));
            }
        });
    }

    startCountdown(minutes = 0.5) {
        const subscription = Countdown.start(minutes).subscribe(
            ({ seconds }) => {
                this.countdown = seconds;
            },
            () => {},
            () => {
                this.receiveSmsDisabled = false;
                subscription.unsubscribe();
            }
        );
    }

    inputFallback(event, index) {
        this.tokenControl.input[index] = event.value;
        this.tokenControl.token = this.tokenControl.input.join('').replace(/\D/g, '');

        if (this.tokenControl.token.length == 5) {
            this.tokenControl.valid = true;
        } else {
            this.tokenControl.valid = false;
        }
    }

    backspaceHandler(event, index) {}

    inputHandler(event, index) {
        const max = 4;

        if (event.key == 'Backspace') {
            if (index <= max && index > -1) {
                if (this.tokenControl.input[index] == '') {
                    let previous = Math.max(0, index - 1);
                    this.tokenControl.input[previous] = '';
                    setTimeout(() => {
                        this.inputs.get(previous).nativeElement.focus();
                    }, 100);
                } else {
                    this.tokenControl.input[index] = '';
                }
            }
        } else if (event.inputType == 'insertFromPaste' && event.timeStamp != this.lastPaste) {
            this.lastPaste = event.timeStamp;
        } else if (event.inputType == 'deleteContentBackward') {
            console.log('delete');
            this.tokenControl.input[index] = '';

            if (index > 0 && index < max) {
                this.inputs.get(index - 1).nativeElement.focus();
            }
        } else if (event.key && !Number.isNaN(Number(event.key))) {
            this.tokenControl.input[index] = event.key;
            setTimeout(() => {
                if (index < max) {
                    this.inputs.get(index + 1).nativeElement.focus();
                }
            }, 100);
        }

        this.tokenControl.token = this.tokenControl.input.join('').replace(/\D/g, '');

        if (this.tokenControl.token.length == 5) {
            this.tokenControl.valid = true;
        } else {
            this.tokenControl.valid = false;
        }
    }
}
